// Matrice de prise en charge des contrats — PM Spec 21/06/2026
// Miroir de backend/services/contract_charges_service.py

export const CHARGE_POSTES = [
  { key: 'truck_rental', label: 'Location camion', editable: false },
  { key: 'fuel', label: 'Carburant', editable: true },
  { key: 'tolls', label: 'Péages', editable: true },
  { key: 'driver', label: 'Chauffeur', editable: true },
  { key: 'escort', label: 'Escorte', editable: true },
  { key: 'handling', label: 'Manutention', editable: true },
  { key: 'cargo_insurance', label: 'Assurance marchandise', editable: true },
  { key: 'fines', label: 'Amendes', editable: true },
  { key: 'route_fees', label: 'Frais de route', editable: true },
  { key: 'other', label: 'Autres', editable: true },
];

export const EDITABLE_POSTES = CHARGE_POSTES.filter((p) => p.editable);

export const BEARERS = [
  { key: 'baobab', label: 'À notre charge', hint: 'compté dans la marge' },
  { key: 'client', label: 'À la charge du client', hint: 'exclu de la marge' },
  { key: 'included_carrier', label: 'Inclus dans le prix du prestataire', hint: 'déjà dans le coût camion' },
  { key: 'na', label: 'Non concerné', hint: 'aucun coût attendu' },
];

export const BEARER_LABELS = BEARERS.reduce((acc, b) => ({ ...acc, [b.key]: b.label }), {});
export const POSTE_LABELS = CHARGE_POSTES.reduce((acc, p) => ({ ...acc, [p.key]: p.label }), {});

export const DEFAULT_MATRIX = {
  fuel: 'baobab',
  tolls: 'baobab',
  driver: 'baobab',
  escort: 'na',
  handling: 'na',
  cargo_insurance: 'na',
  fines: 'na',
  route_fees: 'na',
  other: 'na',
};

// Déduction depuis la politique carburant déjà saisie dans les règles de facturation
export const matrixFromFuelPolicy = (fuelPolicy) => ({
  ...DEFAULT_MATRIX,
  fuel: fuelPolicy === 'excluded' || fuelPolicy === 'client_charge' ? 'client' : 'baobab',
});

export const bearerTone = (bearer) => {
  if (bearer === 'baobab') return 'text-gray-900';
  if (bearer === 'client') return 'text-sky-700';
  if (bearer === 'included_carrier') return 'text-violet-700';
  return 'text-gray-400';
};
